function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.29 3a1.283 1.283 0 00-.895 2.203l6.79 6.791-6.79 6.792a1.281 1.281 0 00.565 2.167c.45.117.927-.018 1.249-.353L12 13.809l6.791 6.79a1.283 1.283 0 101.814-1.814l-6.79-6.79 6.79-6.792a1.283 1.283 0 10-1.814-1.814L12 10.18 5.209 3.39a1.284 1.284 0 00-.92-.388z",
  fill: "#FFF",
  fillRule: "nonzero"
});

function SvgCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgCloseinline;